; (function ($, undefined) {
    "use strict";

    // Name and defaults
    var pluginName = "dynamicContent",
        defaults = {
            // The links to pages to load
            links: 'a[dynamic-content]',
            // The element attributes
            elementAttributes: {},
            // Determines whether the link is active
            isActive: function (link) { return false; },
            // Triggered after initialisation
            onInitialize: function () { },
            // Triggered before loading the pages
            onLoad: function () { },
            // Triggered after all pages are loaded
            onComplete: function (elements, titles, activeIndex) { }
        };

    // Actual plugin constructor
    function Plugin(element, options) {
        this.element = $(element);
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            // Get links
            this.links = $(this.settings.links);

            // Initialize callback
            this.settings.onInitialize.call(this);

            // Load pages
            this.load();
        },
        load: function () {
            // Load callback
            this.settings.onLoad.call(this);

            // Load all pages
            var elements = [], titles = [], requests = [], activeIndex = null;
            $.each(this.links, function (i, link) {
                // Create new element
                var element = $('<div>', this.settings.elementAttributes);

                if (this.settings.isActive(link)) {
                    // Move content to element
                    element.append(this.element.children().detach());
                    activeIndex = i;
                    titles[i] = document.title;
                }
                else {
                    // Request content
                    requests.push($.ajax(link.href, {
                        success: function (data, status, xhr) {
                            element.html(data);
                            titles[i] = xhr.getResponseHeader('X-Title');
                        }
                    }));
                }

                elements.push(element);
            }.bind(this));

            // Wait untill all requests are done
            $.when.apply($, requests).then(function () {
                // Append all elements
                this.element.append(elements);

                // Complete callback
                var elementsCollection = $(elements).map(function () { return this.toArray(); });
                this.settings.onComplete.call(this, elementsCollection, titles, activeIndex);
            }.bind(this));
        }
    });

    // Plugin wrapper
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery);